module.exports = __webpack_public_path__ + "static/bell-interior-01_1000.4c6cf594.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bell-interior-01_1000.jpg
// module id = 734
// module chunks = 35783957827783